// extracted by mini-css-extract-plugin
module.exports = {"badge":"TariffBadge_badge__MzEln","link":"TariffBadge_link__wEH_1"};